export default __webpack_public_path__ + "static/media/ISKO CLASS-3 EXAM PATTERN 2025.6e0b534d.pdf";